export const serviceUrl = "https://omsims-prod.knowdl.com/omsims/simulation/";
export const sessionId = "ea6f04660452e8155a43b36839d182f6";
export const rootRoute = "/sims";